import React from 'react';

/**
 * PublishingStep - Loading state while publishing the app
 * Shows spinner and progress message
 */

const PublishingStep: React.FC = () => {
  return (
    <div className="px-6 py-8 flex flex-col items-center justify-center min-h-[400px]">
      {/* Animated Spinner */}
      <div className="relative mb-6">
        <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center">
          <div className="w-12 h-12 border-4 border-white/10 border-t-[#22c55e] rounded-full animate-spin" />
        </div>
      </div>

      {/* Title */}
      <h2 className="text-xl font-bold text-white mb-2">Publishing your app...</h2>
      
      {/* Description */}
      <p className="text-white/60 text-center max-w-md text-sm">
        This may take a few seconds. Please don't close this window.
      </p>
    </div>
  );
};

export default PublishingStep;

